// extracted by mini-css-extract-plugin
export var curvedBorder = "PageBodyHero-module--curvedBorder--2f69e";
export var curvedImages = "PageBodyHero-module--curvedImages--3h68R";